import { useTranslation } from 'react-i18next'
import { OLIMP_CONFERENCE_2026 } from '../../config/promotions/olimpConference2026'
import { usePromotionModal } from '../../hooks/shared/promotions/usePromotionModal'
import PromotionModal from './PromotionModal'

interface Props {
  isAuthenticated: boolean
  blockedByHigherPriority: boolean
}

/**
 * Composition root for the Olimp Marketplace conference campaign.
 * Config + eligibility live outside the presentational modal.
 */
export default function OlimpConferencePromo({
  isAuthenticated,
  blockedByHigherPriority,
}: Props) {
  const { t } = useTranslation('common')
  const promotion = OLIMP_CONFERENCE_2026
  const { isOpen, onDismiss, onCtaClick } = usePromotionModal({
    promotion,
    isAuthenticated,
    blockedByHigherPriority,
  })

  return (
    <PromotionModal
      open={isOpen}
      onClose={onDismiss}
      onCtaClick={onCtaClick}
      imageSrc={promotion.imageSrc}
      imageAlt={t('promotions.olimpConference.imageAlt', {
        defaultValue: promotion.imageAltFallback,
      })}
      ctaLabel={t('promotions.olimpConference.cta')}
    />
  )
}
